/**
 * 加载动画工具函数
 */

/**
 * 隐藏加载动画
 */
export function hideLoadingAnimation() {
  const loadingEl = document.getElementById('app-loading')
  if (loadingEl) {
    loadingEl.classList.add('hidden')
    // 动画完成后移除元素
    setTimeout(() => {
      loadingEl.remove()
    }, 500)
  }
}
